import { compile } from 'app/infrastructure/js/template';
import { AppSetting } from 'dependencies/appsettings';

export const urlToSurveyManager = (linkUrl: string, favouriteId?: number, caseId?: number) => {
  const context = {
    ...(AppSetting.Integrations as any),
    ...(favouriteId && { favouriteId }),
    ...(caseId && { caseId })
  };
  return compile(linkUrl, context);
};
